
export default (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 726.378 170.079"
            height={props.height}
            width={props.width}
            {...props}
        >
            <path
                d="M154.856 965.035a71.771 71.771 0 0 1-71.75 71.77 71.771 71.771 0 0 1-71.792-71.728 71.771 71.771 0 0 1 71.708-71.814 71.771 71.771 0 0 1 71.834 71.688"
                style={{
                    fill: "#000",
                    fillOpacity: 1,
                }}
                transform="translate(0 -882.284)"
            />
            <g
                style={{
                    display: "inline",
                }}
            >
                <path
                    d="M84.325 885.586a82.075 82.075 0 0 0-82.002 82.123 82.075 82.075 0 0 0 82.1 82.027 82.075 82.075 0 0 0 82.05-82.076v-.096a82.075 82.075 0 0 0-82.148-81.978Zm-.375 17.54a64.286 64.286 0 0 1 64.344 64.212v.074a64.286 64.286 0 0 1-64.267 64.285 64.286 64.286 0 0 1-64.305-64.248 64.286 64.286 0 0 1 64.228-64.322Z"
                    style={{
                        fill: "#ffce35",
                        fillOpacity: 1,
                    }}
                    transform="translate(0 -882.284)"
                />
            </g>
            <g
                style={{
                    display: "inline",
                }}
            >
                <g
                    style={{
                        fontStyle: "normal",
                        fontWeight: 400,
                        fontSize: "133.71968079px",
                        lineHeight: "125%",
                        fontFamily: "sans-serif",
                        letterSpacing: 0,
                        wordSpacing: 0,
                        fill: "#fff",
                        fillOpacity: 1,
                        stroke: "none",
                        strokeWidth: 1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeOpacity: 1,
                    }}
                >
                    <path
                        d="M-670.2 773.359h19.79v-38.11c0-1.605.133-3.477.802-5.082 1.204-3.343 4.28-7.354 9.494-7.354 6.419 0 9.36 5.616 9.36 13.906v36.64h19.791v-38.244c0-1.605.267-3.744.802-5.215 1.338-3.878 4.68-7.087 9.36-7.087 6.553 0 9.629 5.482 9.629 14.976v35.57h19.79v-38.512c0-19.523-9.494-28.348-22.064-28.348-4.814 0-8.825 1.07-12.436 3.21-3.075 1.871-6.017 4.412-8.424 7.889h-.267c-2.808-6.82-9.494-11.1-17.919-11.1-11.232 0-16.982 6.152-19.79 10.297h-.401l-.937-8.825h-17.116c.268 5.75.535 12.703.535 20.86v44.529z"
                        style={{
                            fontStyle: "normal",
                            fontVariant: "normal",
                            fontWeight: 700,
                            fontStretch: "normal",
                            fontFamily: "'Myriad Hebrew'",
                            InkscapeFontSpecification: "'Myriad Hebrew Bold'",
                            fill: "#fff",
                        }}
                        transform="rotate(-45 -1065.011 -441.142)"
                    />
                </g>
                <g
                    style={{
                        fontStyle: "normal",
                        fontWeight: 400,
                        fontSize: "127.30638123px",
                        lineHeight: "125%",
                        fontFamily: "sans-serif",
                        letterSpacing: 0,
                        wordSpacing: 0,
                        fill: "#000",
                        fillOpacity: 1,
                        stroke: "none",
                        strokeWidth: 1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeOpacity: 1,
                    }}
                >
                    <path
                        d="M193.34 1000.255h18.84v-36.282c0-1.528.128-3.31.765-4.838 1.145-3.183 4.073-7.002 9.038-7.002 6.111 0 8.912 5.347 8.912 13.24v34.882h18.841v-36.41c0-1.527.255-3.564.764-4.965 1.273-3.692 4.456-6.747 8.912-6.747 6.238 0 9.166 5.22 9.166 14.258v33.864h18.84V963.59c0-18.587-9.038-26.99-21.005-26.99-4.583 0-8.402 1.02-11.84 3.056-2.927 1.782-5.728 4.201-8.02 7.511h-.254c-2.673-6.493-9.039-10.566-17.06-10.566-10.693 0-16.167 5.856-18.84 9.802h-.382l-.892-8.402H192.83c.255 5.474.51 12.094.51 19.86v42.393zM354.457 975.303c.255-1.4.637-4.329.637-7.639 0-15.404-7.639-31.062-27.753-31.062-21.642 0-31.445 17.44-31.445 33.227 0 19.477 12.094 31.826 33.227 31.826 8.402 0 16.168-1.4 22.533-3.946l-2.546-13.113c-5.22 1.655-10.566 2.546-17.186 2.546-9.039 0-16.932-3.819-17.568-11.84h40.101zm-40.229-13.24c.51-5.22 3.82-12.603 11.967-12.603 8.911 0 10.948 7.893 10.948 12.603h-22.915zM365.986 924.508v13.494h-8.275v14.258h8.275v25.462c0 8.784 1.782 14.767 5.346 18.459 3.056 3.183 8.275 5.474 14.513 5.474 5.475 0 10.058-.764 12.604-1.782l-.128-14.64c-1.4.254-3.31.509-5.728.509-5.857 0-7.639-3.437-7.639-10.948V952.26h13.877v-14.258h-13.877v-17.823l-18.968 4.329zM458.716 963.463c0-14.64-6.62-26.861-27.371-26.861-11.33 0-19.86 3.055-24.188 5.474l3.564 12.476c4.074-2.546 10.821-4.71 17.187-4.71 9.548 0 11.33 4.71 11.33 8.02v.89c-22.024-.126-36.537 7.64-36.537 23.807 0 9.93 7.51 19.096 20.114 19.096 7.384 0 13.75-2.673 17.823-7.638h.382l1.146 6.238h17.44c-.636-3.437-.89-9.166-.89-15.15v-21.642zm-18.842 14.131c0 1.146-.127 2.292-.382 3.31-1.273 3.947-5.22 7.13-10.057 7.13-4.328 0-7.638-2.42-7.638-7.384 0-7.511 7.893-9.93 18.077-9.803v6.747zM515.305 984.342c-2.928 1.273-6.493 2.036-11.076 2.036-9.42 0-17.059-5.983-17.059-17.44-.127-10.185 6.493-17.442 16.677-17.442 5.092 0 8.53.892 10.821 1.91l3.056-14.386c-4.074-1.527-9.676-2.418-14.768-2.418-23.17 0-35.646 14.894-35.646 33.1 0 19.604 12.858 31.953 32.973 31.953 7.383 0 13.876-1.4 17.313-2.928l-2.291-14.385zM525.03 1000.255h19.35v-31.572c0-1.528.127-3.056.382-4.329 1.273-5.983 6.11-9.802 13.24-9.802 2.164 0 3.819.254 5.219.636v-18.332c-1.4-.254-2.292-.254-4.074-.254-5.983 0-13.622 3.819-16.804 12.858h-.51l-.636-11.458H524.52c.254 5.347.51 11.33.51 20.496v41.757zM589.334 1000.255v-62.253h-19.35v62.253h19.35zm-9.675-89.37c-6.238 0-10.312 4.202-10.185 9.803-.127 5.347 3.947 9.676 10.057 9.676 6.366 0 10.44-4.329 10.44-9.676-.128-5.601-4.074-9.802-10.312-9.802zM604.185 924.508v13.494h-8.275v14.258h8.275v25.462c0 8.784 1.782 14.767 5.346 18.459 3.056 3.183 8.275 5.474 14.513 5.474 5.474 0 10.058-.764 12.604-1.782l-.128-14.64c-1.4.254-3.31.509-5.728.509-5.857 0-7.639-3.437-7.639-10.948V952.26h13.877v-14.258h-13.877v-17.823l-18.968 4.329zM664.324 1000.255v-62.253h-19.35v62.253h19.35zm-9.675-89.37c-6.238 0-10.312 4.202-10.185 9.803-.127 5.347 3.947 9.676 10.058 9.676 6.365 0 10.439-4.329 10.439-9.676-.128-5.601-4.074-9.802-10.312-9.802zM720.931 984.342c-2.928 1.273-6.492 2.036-11.076 2.036-9.42 0-17.059-5.983-17.059-17.44-.127-10.185 6.493-17.442 16.678-17.442 5.092 0 8.53.892 10.82 1.91l3.056-14.386c-4.074-1.527-9.675-2.418-14.768-2.418-23.17 0-35.645 14.894-35.645 33.1 0 19.604 12.858 31.953 32.972 31.953 7.384 0 13.876-1.4 17.314-2.928l-2.292-14.385z"
                        style={{
                            fontStyle: "normal",
                            fontVariant: "normal",
                            fontWeight: 700,
                            fontStretch: "normal",
                            fontFamily: "'Myriad Hebrew'",
                            InkscapeFontSpecification: "'Myriad Hebrew Bold'",
                            letterSpacing: "-3.28275895px",
                            fill: props.color,
                        }}
                        transform="translate(0 -882.284)"
                    />
                </g>
            </g>
        </svg>
    );
};